import { useNavigate } from 'react-router-dom';
import { useDemoSession } from '../../auth/DemoSessionProvider';
import { WORKSPACES, workspaceHomePath } from '../../auth/workspaces';
import { Button } from '../../components/ui/Button';

export function WorkspaceAccessPage({ requiredWorkspace }) {
  const navigate = useNavigate();
  const { session, selectWorkspace } = useDemoSession();
  const requiredName = requiredWorkspace?.roleLabel || 'another workspace';

  function handleSwitch() {
    if (!requiredWorkspace) return;
    const next = selectWorkspace(requiredWorkspace.id);
    if (next) {
      navigate(workspaceHomePath(next.workspaceId));
    }
  }

  function handleStay() {
    navigate(session ? workspaceHomePath(session.workspaceId) : '/signin');
  }

  return (
    <section className="rounded-2xl border border-eorig-border bg-white p-6 shadow-eorig-card">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-eorig-muted">
        Demo workspace
      </p>
      <h2 className="mt-2 text-lg font-semibold text-eorig-ink">
        Workspace access required
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-eorig-muted">
        This page belongs to the {requiredName} workspace. You are currently in{' '}
        {session?.roleLabel || 'another workspace'}. Switching workspace
        changes the demo identity used for API headers; it is not production
        authentication.
      </p>
      <div className="mt-5 flex flex-wrap gap-2">
        {requiredWorkspace ? (
          <Button variant="navy" onClick={handleSwitch}>
            Switch workspace
          </Button>
        ) : null}
        <Button variant="ghost" onClick={handleStay}>
          Go to current dashboard
        </Button>
      </div>
      <div className="mt-4 text-xs text-eorig-muted">
        Available workspaces:{' '}
        {WORKSPACES.map((workspace) => workspace.roleLabel).join(', ')}
      </div>
    </section>
  );
}
